var map = {
	"./chain_arbitrum.png": 39035,
	"./chain_bsc.png": 15969,
	"./chain_dark_uptick.png": 30546,
	"./chain_eth.png": 97544,
	"./chain_iris.png": 53976,
	"./chain_polygon.png": 18791,
	"./chain_uptick.png": 82361,
	"./chian_weth.png": 59461,
	"./logo_arbitrum.png": 38661,
	"./logo_arbitrum1.png": 90456,
	"./logo_bsc.png": 73559,
	"./logo_bsc1.png": 88462,
	"./logo_irisnet.png": 13541,
	"./logo_irisnet1.png": 53816,
	"./logo_polygon.png": 70089,
	"./logo_polygon1.png": 57316,
	"./logo_uptickchain.png": 844,
	"./logo_uptickchain1.png": 35743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92864;